import React from "react";

import { SelectForm } from "../../../../components/Input";
import {
  Card,
  CardLabel,
  HelperText,
} from "../../../../components/MobileForm/styles";
import { StaticInstrument } from "./styles";
import {
  instrumentLabelOf,
  SOURCE_COUNTRY_HELPER,
  SOURCE_COUNTRY_OPTIONS,
} from "./constants";
import { MobileSourceCountryFormProps } from "./types";

export const MobileSourceCountryForm: React.FC<
  MobileSourceCountryFormProps
> = ({ control, instrument, defaultCountry, isSubmitting }) => (
  <Card>
    <CardLabel as="span">Instrument</CardLabel>
    <StaticInstrument>{instrumentLabelOf(instrument)}</StaticInstrument>

    <CardLabel htmlFor="mobile-source-country">Source country</CardLabel>
    <SelectForm
      id="mobile-source-country"
      name="country"
      control={control}
      required={false}
      defaultValue={defaultCountry}
      options={SOURCE_COUNTRY_OPTIONS}
      disabled={isSubmitting}
    />
    <HelperText>{SOURCE_COUNTRY_HELPER}</HelperText>
  </Card>
);
